export default {
	CANCELED: 400,
}
